{
	"submitTitle": "Materiaal selecteren",
	"summary": {
		"title": "Samenvatting",
		"declarationTypeTitle": "Type verklaring",
		"projectReferenceTitle": "Projectreferentie"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Selecteer het type verklaring",
			"customerProject": {
				"title": "Klantproject",
				"description": "Het materiaal is gebruikt voor een extern project. Ik moet nu een verklaring verstrekken met de CO\u2082-reducties voor mijn klant."
			},
			"internalProjectOrProduct": {
				"title": "Intern project / product",
				"description": "Het materiaal is gebruikt voor een intern project of product. Ik moet een verklaring aanmaken om de CO\u2082-reducties voor onze eigen activiteiten te claimen."
			}
		},
		"addProjectReferenceSection": {
			"title": "Projectreferentie toevoegen",
			"subTitle": "U moet CO\u2082-reducties toewijzen aan een projectreferentie waarvoor u de verklaring wilt aanmaken.",
			"projectReferencePlaceholder": "Projectreferentie"
		},
		"selectProjectSection": {
			"title": "Selecteer een project",
			"createNewProjectPlaceholder": "Nieuw project aanmaken"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Type verklaring is verplicht",
		"projectReferenceRequired": "Projectreferentie is verplicht",
		"fetchProjectsError": "Eerdere projecten konden niet worden opgehaald"
	}
}
